export const formatOrderStatus = (input) => {
  if (input === null || input === undefined) return "N/A";

  return input
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" ");
};

// FUNCTION: Format Tasker Status
// PURPOSE: Format the tasker status to have the first letter of each word capitalized, if (_) consider it as a (-)
export const formatTaskerStatus = (input) => {
  if (input === null || input === undefined) return "N/A";
  return input
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join("-");
};

export const currencyFormatter = new Intl.NumberFormat("en-GH", {
  style: "currency",
  currency: "GHS",
});

export const formatPrice = (amount) => {
  if (amount === undefined || amount === null) {
    return "0.00"; // Default to 0.00 for undefined or null
  }
  return amount.toString().includes(".") ? amount : `${amount}.00`; // Add .00 if no decimal is present
};

export const stringToBoolean = (str) => {
  if (str.toLowerCase() === "true") return true;
  if (str.toLowerCase() === "false") return false;
  throw new Error("Invalid input");
};

export const capitalizeEachWord = (text) => {
  return text
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const trimTextWithEllipsis = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  } else {
    return text;
  }
};

// Sanitize: removes spaces around hyphens
export const sanitizeHyphens = (value) => {
  try {
    // Replace spaces around hyphens with a single hyphen
    return String(value)
      .replace(/\s*-\s*/g, "-") // normalize spacing around hyphens
      .replace(/\s+/g, " ") // normalize multiple spaces to single space
      .trim(); // trim leading/trailing spaces
  } catch {
    return value;
  }
};
